import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ServiceData } from 'src/app/core/models/table/service-data.model';
import { TableConfigurationModel } from 'src/app/core/models/table/table-configuration.model';
import { ListLayoutExtendableComponent } from '../list-layout/list-layout-extendable/list-layout-extendable.component';
import { ListFilterModel } from 'src/app/core/models/table/list-filter.model';
import { TableActionsModel } from 'src/app/core/models/table/table-action.model';
import { AccountingMappingRulesConfig } from './accounting-mapping-rules-list.config';
import { ActionIdEnum } from 'src/app/core/enums/list-layout/action-id-enum';
import { ButtonIdEnum } from 'src/app/core/enums/list-layout/button-id-enum';
import Swal from 'sweetalert2';
import { AccountingObjectMappingModel } from 'src/app/core/models/accounting/accounting-object-mapping.model';
import { SourceObjectTypeEnum } from 'src/app/core/enums/accounting/source-object-type-enum';
import { TargetObjectTypeEnum } from 'src/app/core/enums/accounting/target-object-type-enum';
import { AccountingConfigurationsModel } from 'src/app/core/models/accounting/account-settings.model';


@Component({
  selector: 'app-accounting-mapping-rules-list',
  templateUrl: './accounting-mapping-rules-list.component.html',
  styleUrls: ['./accounting-mapping-rules-list.component.scss']
})
export class AccountingMappingRulesListComponent extends ListLayoutExtendableComponent {

  protected override searchPlaceHolderText: string = '';
  tableConfig: TableConfigurationModel = new TableConfigurationModel();
  serviceData: ServiceData = new ServiceData();
  newObject: boolean = false;

  @Input() public inputModel: AccountingConfigurationsModel = new AccountingConfigurationsModel();
  @Output() public updateObjectMapping = new EventEmitter<any>;

  override ngOnInit(): void {
    this.tableConfig = new AccountingMappingRulesConfig();
    this.listItems = Object.assign([], this.inputModel.objectMappings);
    this.inputModel.objectMappings = this.listItems;
  }

  override  ngOnDestroy() {
    this.listItems = [];
  }

  pointerToOldEnableLineIndex: any;

  override rowActionSelected(rowAction: TableActionsModel): void {
    switch (rowAction.actionIdSelected) {
      case ActionIdEnum.EnableDisable:
        if (rowAction.index !== this.tableConfig.activeInputFieldIndex) {
          if (this.pointerToOldEnableLineIndex) {
            this.pointerToOldEnableLineIndex.enableInLineEditing = 0;
          }
          this.pointerToOldEnableLineIndex = rowAction.model;
          this.tableConfig.activeInputFieldIndex = rowAction.index;
          rowAction.model.enableInLineEditing = 1;
        } else {
          rowAction.model.enableInLineEditing = 0;
          this.listItems[rowAction.index!] = rowAction.model;
          this.tableConfig.activeInputFieldIndex = undefined;
        }
        break;
      case ActionIdEnum.Delete:
        Swal.fire({
          title: $localize`:@@:Delete Mapping`,
          text: $localize`:@@:Are you sure you want to delete this object mapping?`,
          icon: 'warning',
          color: 'var(--vz-body-color)',
          background: 'var(--vz-body-bg)',
          showCancelButton: true,
          confirmButtonColor: 'rgb(3, 142, 220)',
          cancelButtonColor: 'rgb(243, 78, 78)',
          confirmButtonText: $localize`:@@:Yes, Delete`,
          cancelButtonText: $localize`:@@:Cancel`,
        }).then(result => {
          if (result && result.isConfirmed) {
            this.listItems.splice(rowAction.index, 1);
            this.tableConfig.activeInputFieldIndex = undefined;
            this.inputModel.objectMappings = this.listItems;
          }
        });
        break;
    }
  }

  override buttonActionSelected(buttonAction: any): void {
    switch (buttonAction) {
      case ButtonIdEnum.CreateNew:
        if (this.tableConfig.activeInputFieldIndex === undefined) {
          if (this.pointerToOldEnableLineIndex) {
            this.pointerToOldEnableLineIndex.enableInLineEditing = 0;
          }
          this.newObject = true;
          this.listItems.unshift(new AccountingObjectMappingModel(SourceObjectTypeEnum.Category, '', '', TargetObjectTypeEnum.CustomField,'', ''));
          this.listItems[0].enableInLineEditing = 1;
          this.tableConfig.activeInputFieldIndex = 0;
        }
        break;
    }
  }

  override filterSelected(filterSelected: ListFilterModel): void {

  }

}
